import { createSelector } from "@ngrx/store";
import { type BackgroundsState } from "./backgrounds.interface";
import {
  DELETE_BACKGROUND_SUCCESS,
  GET_BACKGROUNDS,
  GET_BACKGROUNDS_FAILURE,
  GET_BACKGROUNDS_SUCCESS,
  type BackgroundsActions,
} from "./backgrounds.actions";

export const initialBackgroundsState: BackgroundsState = {
  backgrounds: null,
  loading: false,
  error: undefined,
};

export function backgroundsReducer(
  state: BackgroundsState = initialBackgroundsState,
  action: BackgroundsActions,
): BackgroundsState {
  switch (action.type) {
    case GET_BACKGROUNDS:
      return {
        ...state,
        loading: true,
        error: undefined,
      };
    case GET_BACKGROUNDS_SUCCESS:
      return {
        ...state,
        backgrounds: action.payload,
        loading: false,
      };
    case GET_BACKGROUNDS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case DELETE_BACKGROUND_SUCCESS:
      return {
        ...state,
        backgrounds: (state.backgrounds ?? []).filter(
          (b) => b.backgroundId !== action.payload,
        ),
      };
    default:
      return state;
  }
}

export const getBackgroundsRootState = (state: {
  backgrounds: BackgroundsState;
}): BackgroundsState => state.backgrounds;

export const getBackgroundsList = createSelector(
  getBackgroundsRootState,
  (s) => s.backgrounds,
);

export const getBackgroundsLoading = createSelector(
  getBackgroundsRootState,
  (s) => s.loading,
);
